<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-printer-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                            <p class="cf-modal-head__sub">Aperçu avant impression</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between">
                            <div class="box-title">
                                {{titlemodal}}
                            </div>


                        </div>


                        <div class="box-body !p-0">

                            <div class="grid lg:grid-cols-2 gap-6">


                                <div class="space-y-2">
                                    <label class="ti-form-label dark:text-defaulttextcolor/70 mb-0">Impression en</label>
                                    <select v-model="taillemodel" class="form-control mb-3">
                                        <option value="A4">A4</option>
                                        <option value="A4landscape">A4 landscape</option>
                                        <option value="A5">A5</option>
                                        <option value="A5landscape">A5 landscape</option>
                                    </select>
                                </div>


                                <div  class="space-y-2">
                                    <div class="w-full flex grid-cols-2">

                                        <div class="box-title mb-2 sm:mb-0"></div>

                                        <div class="inline-flex rounded-md shadow-sm w-full" role="group" aria-label="Basic example">

                                            <div class="grid lg:grid-cols-2 gap-6 w-full">
                                                <div class="space-y-2">
                                                    <label >&nbsp;&nbsp;</label>
                                                    <input class="w-full" type="date"  @change="refresh" v-model="datedebut" placeholder="Date début">
                                                </div>

                                                <div class="space-y-2">
                                                    <label >&nbsp;&nbsp;</label>
                                                    <input class="w-full" type="date" @change="refresh" v-model="datefin" placeholder="Date fin">
                                                </div>
                                            </div>


                                        </div>
                                    </div>


                                </div>



                            </div>


                            <div class="grid lg:grid-cols-3 gap-6 mt-4">

                                <div class="space-y-2">
                                    <button @click="print4" class="ti-btn ti-btn-success-full w-full"> Imprimer</button>


                                </div>

                                <div class="space-y-2">
                                    <button    @click="ExportExcel('xlsx',`${titlemodal} période (${datedebut} - ${datefin})`)"
                                               class="ti-btn ti-btn-danger-full  w-full"> Excel</button>
                                </div>


                            </div>



                            <div class="grid lg:grid-cols-2 gap-6 mt-4">

                                <div class="space-y-2">
                                    <input v-model="searchnomcaisse" class="form-control form-control-lg w-full" type="text"
                                           placeholder="Rechercher ."
                                           aria-label=".form-control-lg example">

                                </div>


                                <div class="space-y-2">

                                    <div class="space-y-2">
                                        <select class="form-control mb-3 w-full" v-model="selectedaffichage">
                                            <option value="">Affichage simple</option>
                                            <option value="groupby">Affichage grouper par personnel</option>
                                        </select>
                                    </div>


                                </div>




                            </div>





                            <div class="table-responsive mybodyheight300px">


                                <div ref="printdoc"  class="my-5 page pagebreak"  >


                                    <div class="p-5">

                                        <section class="top-content mb-5 bb d-flex justify-content-between">
                                            <div class="logo">
                                                <img v-if="$store.state.etatlogo" :src="$store.state.etatlogo" alt="" style="width: 10%" class="img-fluid">
                                            </div>
                                            <div class="top-left">
                                                <div class="logo">

                                                </div>
                                            </div>
                                        </section>

                                        <section class="mt-5">
                                            <div class="grid lg:grid-cols-2 gap-6 row">

                                                <div class="col-6">
                                                    <table class="table table-bordered">
                                                        <tbody >

                                                        <tr>
                                                            <td >Raison Social : {{$store.state.etatraisonsocial}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td >Ifu : {{$store.state.etatifu}} /  RC N° RCCM: {{$store.state.etatrccm}} </td>
                                                        </tr>
                                                        <tr>
                                                            <td >Téléphone : {{$store.state.etattelephone}} / {{$store.state.etatadresse}}</td>
                                                        </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="col-6 ">


                                                    <table class="table table-bordered w-full">
                                                        <tbody >
                                                        <tr>
                                                            <td style="text-align: center" colspan="2" >{{soustitre}}</td>

                                                        </tr>
                                                        <tr>
                                                            <td v-if="viewperiode" style="text-align: center">PERIODE</td>
                                                            <td v-else style="text-align: center">JOURNEE DU</td>
                                                            <td style="text-align: center">IMPRIMER PAR</td>
                                                        </tr>
                                                        <tr>
                                                            <td v-if="viewperiode" style="text-align: center">{{datedebut+' - '+datefin}}</td>
                                                            <td v-else style="text-align: center">{{datejournee}}</td>
                                                            <td style="text-align: center">{{$store.state.appusername}}</td>
                                                        </tr>

                                                        <tr v-if="!viewperiode">
                                                            <td style="text-align: center" colspan="2" >PERIODE {{datedebut+' - '+datefin}}</td>

                                                        </tr>




                                                        </tbody>
                                                    </table>


                                                </div>

                                            </div>


                                        </section>


                                        <section   class="product-area mt-3">

                                            <table ref="exportable_table" v-if="selectedaffichage===''" class="mb-3 table table-striped table-bordered table-hover dataTable no-footer dtr-inline mytable w-full">
                                                <thead>
                                                <tr>
                                                    <th>N°</th>
                                                    <th>Date</th>
                                                    <th>Caisse</th>
                                                    <th>Caissier(e)</th>
                                                    <th>Type document</th>
                                                    <th>Référence</th>
                                                    <th>N° doc </th>
                                                    <th>Bénéficiaire / Banque / Client / Fournisseur</th>
                                                    <th>Libellé opération</th>
                                                    <th>Sortie de caisse </th>
                                                    <th>Entrée de caisse </th>
                                                    <th>Solde</th>
                                                    <th>Crée le</th>

                                                </tr>
                                                </thead>
                                                <tbody>
                                                <template v-if="filterdatatable.length">
                                                    <template   v-for="(datavalue,index) in filterdatatable" :key="index">
                                                    <tr style="font-weight: 600;/*background: khaki;*/" >

                                                        <td  data-label="N°  : "   >{{ index+1 }}</td>
                                                        <td  data-label="Date  : "   >{{ datavalue.dateop }}</td>
                                                        <td  data-label="Caisse  : "   >{{ datavalue.caisse }}</td>
                                                        <td  data-label="Caissier(e)  : "   >{{ datavalue.caissiere }}</td>
                                                        <td data-label="Type document : " >{{  datavalue.typedoc }}</td>
                                                        <td data-label="Référence : " >{{  datavalue.refdoc }}</td>
                                                        <td data-label="N° doc : " >{{  datavalue.autredoc }}</td>
                                                        <td data-label="Bénéficiaire / Banque / Client / Fournisseur : " >{{  datavalue.benef }}</td>
                                                        <td data-label="Libellé opération : " >{{  datavalue.liboperation }}</td>
                                                        <td data-label="Sortie de caisse : " >{{  formatMoney(datavalue.sortiecaisse)  }}</td>
                                                        <td data-label="Entrée de caisse : " >{{  formatMoney(datavalue.entreecaisse) }}</td>
                                                        <td data-label="Solde : " >{{  formatMoney(datavalue.solde) }}</td>
                                                        <td data-label="Crée le : " >{{  (datavalue.creele) }}</td>

                                                    </tr>


                                                    </template>
                                                </template>



                                                <template v-else>
                                                    <tr >
                                                        <td colspan="15"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                    </tr>

                                                </template>




                                                </tbody>

                                                <!--tfoot>
                                                <tr>
                                                    <td colspan="10" data-label="TOTAL  : "><p class="text-center"><strong>TOTAL</strong></p> </td>
                                                    <td data-label="Montant  : "><p class="text-center"><strong>{{formatMoney(montanttolal)}}</strong></p> </td>
                                                </tr>
                                                </tfoot-->

                                            </table>

                                            <!--table ref="exportable_table" v-if="selectedaffichage==='groupby'" class="table table-striped table-bordered table-hover dataTable no-footer dtr-inline mytable w-full">
                                                <thead>
                                                <tr>
                                                    <th>N°</th>
                                                    <th>Date</th>
                                                    <th>N° document</th>
                                                    <th>Saisie par</th>
                                                    <th>Motif</th>
                                                    <th>Montant HT</th>
                                                    <th>Montant TVA</th>
                                                    <th>Montant TTC</th>
                                                    <th>Montant restant à payer</th>
                                                    <th>Montant total régler</th>

                                                </tr>
                                                </thead>
                                                <tbody>
                                                <template v-if="Object.keys(filterdatatable).length">

                                                    <template v-for="(myvalue,index) in filterdatatable" :key="index">


                                                        <tr style="font-weight: 600;/*background: khaki;*/" >
                                                            <td colspan="10" style="text-align: center"> <h4>Client /Fournisseur : {{ myvalue[0].namecltfrs }} </h4> </td>
                                                        </tr>
                                                        <template v-for="(datavalue,index) in myvalue" :key="index">

                                                            <tr style="font-weight: 600;/*background: khaki;*/" >

                                                                <td  data-label="N°  : "   >{{ index+1 }}</td>
                                                                <td  data-label="Date  : "   >{{ datavalue.docdate }}</td>
                                                                <td data-label="N° document : " >{{  datavalue.numdoc }}</td>
                                                                <td data-label="Saisie par : " >{{  datavalue.saisiepar }}</td>
                                                                <td data-label="Motif : " >{{  datavalue.observation }}</td>
                                                                <td data-label="Montant HT : " >{{  formatMoney(datavalue.mtnttotalht) }}</td>
                                                                <td data-label="Montant TVA : " >{{  formatMoney(datavalue.mtnttva) }}</td>
                                                                <td data-label="Montant TTC : " >{{  formatMoney(datavalue.mtnttotalttc) }}</td>
                                                                <td data-label="Montant restant à payer : " >{{  formatMoney(datavalue.mtnttotalttctrt) }}</td>
                                                                <td data-label="Montant total régler : " >{{  formatMoney(datavalue.montanttotalregle) }}</td>



                                                            </tr>

                                                        </template>


                                                    </template>


                                                </template>



                                                <template v-else>
                                                    <tr >
                                                        <td colspan="9"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                    </tr>

                                                </template>




                                                </tbody>


                                            </table-->

                                        </section>

                                        <section class="balance-info">
                                            <div class="col-12">


                                            </div>
                                        </section>
                                        <section class="balance-info mt-3">
                                            <div class="grid grid-cols-2  gap-x-6 mt-3 row">
                                                <div class="col-6 ">

                                                    <!--div style="float: left;    margin-left: 80px;">
                                                        <p style="text-align: center;"  class="m-0 font-weight-bold"> Caissier </p>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <p style="text-align: center;" >{{}}</p>
                                                    </div>

                                                </div>

                                                <div class="col-6 ">

                                                    <div style="float: right;margin-right: 85px;">
                                                        <p style="text-align: center;"  class="m-0 font-weight-bold"> RESPONSABLE TRESORERIE </p>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <br>
                                                        <p style="text-align: center;" > {{$store.state.paramsapp.signataire.caisseresponsablefinancier.name}}</p>
                                                    </div-->

                                                </div>

                                            </div>
                                        </section>



                                    </div>




                                </div>




                            </div>


                        </div>



                    </div>






                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="print4" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-printer-line align-middle"></i> Imprimer</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>
</template>

<script>
    /*import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";*/
    import {
        currencyFormatDE, currencyFormatMonney,
        currentDate,
        currentDateTime,
        ExportExcel, FormatNumber,
        getYear, groupByKey,
        impression, isValidDateString, NumbertoLettre,
        randomString
    } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    import qrcode from 'qrcode.vue'
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

            }

        },
        computed:{

            soustitre(){
                this.taillemodel='A4';  return this.titlemodal+``
            },
            viewall(){
                if (this.mmois==="" || this.manne===""){

                    return true

                }
                else{

                    return false

                }


            },


            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){


                let mvalue=this.datatable,$dataretun=[];

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

                if (this.searchnomcaisse!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.numdoc.toLowerCase().includes(t.searchnomcaisse.toLowerCase())

                    })

                }

                if (this.searchbeneficiaire!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.titre.toLowerCase().includes(t.searchbeneficiaire.toLowerCase())

                    })

                }


                if (this.selectedaffichage===''){

                    /*this.montanttolal=0

                    let t=this
                    mvalue.forEach(function (item) {
                        t.montanttolal=parseFloat(t.montanttolal)+parseFloat(item.montant)

                    })*/

                    $dataretun=mvalue

                }
                else {

                    this.montanttolalgroupby=0

                  /*  let t=this
                    mvalue.forEach(function (item) {
                        t.montanttolalgroupby=parseFloat(t.montanttolalgroupby)+parseFloat(item.montant)

                    })*/

                    let $datagroupby=groupByKey(mvalue,'namecltfrs')

                    /*

                    for (let [index, $line] of Object.entries($datagroupby)) {

                        let t=this,montanttolal=0
                        $line.forEach(function (item) {
                            montanttolal=parseFloat(montanttolal)+parseFloat(item.montant)

                        })

                        $line.forEach(function (item) {
                            item.montanttolal=montanttolal

                        })

                        $line.montanttolal=montanttolal

                    }

                */


                    $dataretun=$datagroupby

                }

                return $dataretun;


            },


        },
        components: {
            /*templatesite,
            appheader,
            appsidebar,
            appmenu,*/
            qrcode

        },

        data() {
            return {
                opened:[],
                mfontsize:10,
                taillemodel:'A4',
                mgetyear:getYear(),
                datenow:currentDate(),
                isdisplay:false,
                viewperiode:false,
                titlemodal:"",
                datatable:[],
                datasuiviereglement:[],
                viewdrop:false,
                tabvalue:{},
                selectedaffichage:'',
                datejournee:"",
                datedebut:"",
                numpidcaisse:"",
                datefin:"",
                searchnomcaisse:"",
                searchbeneficiaire:"",
                typedoc:"",


                montanttolal:0,
                montanttolalrestant:0,
                montanttolalremise:0,
                montanttolalgroupbyremise:0,
                montanttolalgroupby:0,
                montanttolalgroupbyrestant:0,


                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 1,
                Defaultpage: 1,
                DefaultperPage: 1,
                pages: [],

                textToEncode: '',  // Initial text to encode in QR code
                size: 100,              // Size of the QR code
                level: 'L'              // Error correction level ('L', 'M', 'Q', 'H')
            };
        },
        methods: {

            toggle(id,datavalue) {
                const indexp = this.opened.indexOf(id);
                this.opened=[];
                this.datasuiviereglement=[];
                this.datasuiviereglement=datavalue;
                const index = this.opened.indexOf(id);
                let montanrecuoudecaisse=0;


                this.datasuiviereglement.forEach(function (items) {
                    montanrecuoudecaisse=parseFloat(montanrecuoudecaisse)+parseFloat(items.montanrecuoudecaisse)
                })

                this.totalmontanrecuoudecaisse=montanrecuoudecaisse;

                if (indexp > -1) {
                    this.opened.splice(0, 1)

                }
                else{


                    if (index > -1) {
                        this.opened.splice(index, 1)
                    } else {
                        this.opened.push(id)
                    }


                }


            },



            formatMonney(value){
                return currencyFormatMonney(value)

            },

            numbertolettre(chiffre){

                return NumbertoLettre(chiffre)

            },


            btnviewdrop(){

                if(this.viewdrop===true){

                    this.viewdrop=false;

                }else{

                    this.viewdrop=true;

                }



            },


            ExportExcel(type,name, fn, dl) {
                name=name+"_"+currentDateTime()
                var elt = this.$refs.exportable_table;
                ExportExcel(type,name, fn, dl,elt);

            },



            async print4 () {


                let t=this
                let $style=[];

                let options = {  name: '_blank', }


                if (this.taillemodel==="A4landscape" || this.taillemodel==="A5landscape" ){

                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/stylelandscape1.css',
                        process.env.VUE_APP_URL+'print/stylelandscape.css'
                    ]


                }

                if (this.taillemodel==="A4" || this.taillemodel==="A5" ){


                    $style= [
                        process.env.VUE_APP_URL+'print/bootstrap.min.css',
                        process.env.VUE_APP_URL+'print/styleportrait.css',
                        // process.env.VUE_APP_URL+'print/custom_print_a4.css',
                    ]

                }

                //const printContent = this.$refs.printdoc.innerHTML;
               // impression(printContent,$style,window.document.title,[],{ format: this.taillemodel })

                setTimeout(() => {
                    const printContent = this.$refs.printdoc.innerHTML;
                    impression(printContent,$style,window.document.title,[],{ format: this.taillemodel })

                }, 500);

            },



            formatMoney(value){
                return currencyFormatDE(value)

            },


            formatnumber(value){
                return FormatNumber(value)

            },



            returnFloatconvert(value){

                //console.log('value ',value)

                let mval= parseFloat(value)

                return mval.toFixed(4)
            },

            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },

            selected(datavalue){


                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { typ: this.typedoc, value: datavalue};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionne', elementSelectionne);

                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },


            printline(value)
            {
              console.log("value **************** ",value)
            },
            checkZero(i)
            {
                if (i < 10)
                {
                    i = "0" + i
                };  // add zero in front of numbers < 10

                return i;
            },

            async show(titlemodal,numpidcaisse,datedouverture){


                this.titlemodal=titlemodal
                //this.typedoc=typedoc

                /*this.numpidcaisse=numpidcaisse
                this.datedebut=(datedouverture!=="")?datedouverture:this.$store.state.appserverdate
                this.datefin=(datedouverture!=="")?datedouverture:this.$store.state.appserverdate*/

                if (datedouverture!==""){

                    this.viewperiode=false;
                    this.datejournee=datedouverture
                    this.datedebut=datedouverture
                    this.datefin=datedouverture
                    this.numpidcaisse=numpidcaisse

                    this.refresh()

                }else{

                    this.viewperiode=true;
                    this.datedebut=currentDate()
                    this.datefin=currentDate()
                    this.numpidcaisse=numpidcaisse
                    this.refresh()


                }

                this.isdisplay=true;
            },


            async refresh(){

                if (!isValidDateString(this.datedebut) || !isValidDateString(this.datefin)){return }


                this.$store.dispatch('lancerchargement',true)
                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/c/rapport1247ifufjf85/'+this.datedebut+'/'+this.datefin+'/'+this.numpidcaisse+'/'+this.$store.state.appsociete+'/8954fbrouillardecaisse11515/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)
                        t.datatable=[];

                        if(res.data.success){

                            t.datatable=res.data.m


                            //t.isdisplay=true;

                        }
                        else{
                            t.datatable=[];


                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })













            },


            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:92vh; overflow:hidden; }
.cf-dialog--xl { max-width:1050px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .opened {
        background-color: red;
    }


    .table td {
        cursor: pointer;
    }

    .h-screen{

        height: 300px!important;

    }

    .mybodyheight200px{
        height: 200px;
    }

    .mybodyheight300px{
        height: 300px;
    }

    .mybodyheight400px{
        height: 400px;
    }

    .mybodyheight500px{
        height: 500px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xl { max-width:100%; }


        .h-screen,.mybodyheight200px,.mybodyheight300px, .mybodyheight400px,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>